<script>
    import { createEventDispatcher } from "svelte";

    import { user } from "../../../stores";
    import { isEnvNewOrApp } from "../../../Utils/utilRoute.svelte";

    import {
        getAmountInCurrency,
        getBillingType,
        getText,
    } from "../../../Utils/utilFunctions.svelte";

    import {
        CardLayout,
        NotificationModal,
    } from "../../../Components/Common/index.svelte";

    import { BillingType } from "../../../Utils/utilEnums.svelte";
    import DecimalInput from "../../../Components/Common/DecimalInput.svelte";
    import { editIcon } from "../../../Utils/utilConstants.svelte";

    export let hospitalPIPData = {};
    export let isPIPEditEnabled = false;
    export let isUpdatingPIPData = false;

    let isConfirmCancelModalOpen = false;

    $: isUserEnableEditPIP = $user.role == 100 || $user.role == 20;

    $: isValidEmail = hospitalPIPData.email
        ? String(hospitalPIPData.email)
              .toLowerCase()
              .match(
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              )
        : true;

    $: if (!isUserEnableEditPIP || isPIPEditEnabled)
        if(btnOptions.length > 0)
            btnOptions[0].isHidden = true;
    else 
        if(btnOptions.length > 0) 
            btnOptions[0].isHidden = false;

    const btnOptions = isEnvNewOrApp() ? [
        {
            iconName: "editIcon",
            iFont: editIcon,
            iconFunction: () => _toggleShowHidePIP(),
            hasTooltip: false,
            btnText: "Edit",
        },
    ] : [];

    const dispatch = createEventDispatcher();

    const discardChanges = () => {
        _closeConfirmCancelModal();
        dispatch("cancelEdit");
    };

    // HELPER FUNCTIONS
    const _toggleShowHidePIP = () => {
        isPIPEditEnabled = true;

        if (
            hospitalPIPData?.billingType ||
            hospitalPIPData?.billingType != 2 ||
            hospitalPIPData?.billingType != 6
        )
            hospitalPIPData.billingType = 2;
    };

    const _openConfirmCancelModal = () => (isConfirmCancelModalOpen = true);

    const _closeConfirmCancelModal = () => (isConfirmCancelModalOpen = false);
</script>

<CardLayout title="Public in Private Details" {btnOptions}>
    <div class="flex flex-col flex-1 px-2 py-4 gap-y-4 w-full">
        <div class="flex items-center gap-x-4">
            <p class="title">Email:</p>

            {#if !isPIPEditEnabled}
                <p class="content">
                    {hospitalPIPData.email
                        ? getText(hospitalPIPData.email)
                        : "-"}
                </p>
            {:else}
                <!-- <input type="text"> -->
                <div class="content flex flex-col gap-y-2">
                    <input
                        type="text"
                        class="input input-sm max-w-sm {isValidEmail
                            ? ''
                            : 'border-error'}"
                        autocomplete="off"
                        placeholder="Public in Private Email"
                        bind:value={hospitalPIPData.email}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                        }}
                    />

                    {#if !isValidEmail}
                        <span class="text-error">Invalid Email</span>
                    {/if}
                </div>
            {/if}
        </div>

        <div class="flex items-center gap-x-4">
            <p class="title">Billing Type:</p>

            {#if !isPIPEditEnabled}
                {#if !hospitalPIPData?.billingType}
                    <p class="content">Missing Billing Type</p>
                {:else}
                    <p class="contnet">
                        {getBillingType(hospitalPIPData.billingType)}
                    </p>
                {/if}
            {:else}
                <select
                    class="select w-full select-sm max-w-sm"
                    bind:value={hospitalPIPData.billingType}
                >
                    {#each BillingType as bs}
                        {#if [2, 6, 7].includes(bs.id)}
                            <option value={bs.id} disabled={!bs.id}>
                                {bs.type}
                            </option>
                        {/if}
                    {/each}
                </select>
            {/if}
        </div>

        <div class="flex items-center gap-x-4">
            <p class="title">Unit Value Amount:</p>

            {#if !isPIPEditEnabled}
                {#if !hospitalPIPData?.setUnitValue}
                    <p class="content">{getAmountInCurrency(0)}</p>
                {:else}
                    <p class="content">
                        {getAmountInCurrency(hospitalPIPData.setUnitValue)}
                    </p>
                {/if}
            {:else}
                <DecimalInput
                    inputClass="w-full input-sm max-w-sm"
                    bind:value={hospitalPIPData.setUnitValue}
                />
            {/if}
        </div>

        <div class="flex items-center gap-x-4">
            <p class="title">Per-MBS Schedule Amount:</p>

            {#if !isPIPEditEnabled}
                {#if !hospitalPIPData?.perMbsSchedule}
                    <p class="content">{getAmountInCurrency(0)}</p>
                {:else}
                    <p class="content">
                        {getAmountInCurrency(hospitalPIPData.perMbsSchedule)}
                    </p>
                {/if}
            {:else}
                <DecimalInput
                    inputClass="w-full input-sm max-w-sm"
                    bind:value={hospitalPIPData.perMbsSchedule}
                />
            {/if}
        </div>

        {#if isPIPEditEnabled}
            <div class="flex gap-x-4 w-full justify-end">
                <button
                    class="btn btn-sm btn-error"
                    disabled={isUpdatingPIPData}
                    on:click|preventDefault={_openConfirmCancelModal}
                >
                    Cancel Edit
                </button>

                <button
                    class="btn btn-sm btn-secondary"
                    disabled={isUpdatingPIPData}
                    on:click|preventDefault={() => dispatch("savePIP")}
                >
                    {isUpdatingPIPData ? "Updating" : "Update"}
                </button>
            </div>
        {/if}
    </div>
</CardLayout>

<NotificationModal
    title="Warning"
    cancelText="Back"
    submitText="Discard Changes"
    isModalOpen={isConfirmCancelModalOpen}
    closeModal={_closeConfirmCancelModal}
    confirmAction={discardChanges}
    hideCrossButton
    closeModalFunction={_closeConfirmCancelModal}
>
    Do you want to discard your changes?
</NotificationModal>

<style>
    .title {
        width: 240px;
    }

    .content {
        width: calc(100% - 240px);
    }

    .transition {
        transition: 0.5s linear;
    }

    input,
    select {
        background-color: #e5e7eb;
        border-radius: 2px;
        font-size: 15px;
    }
</style>
